// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".category-header {\n  background-color: #00BEA4 !important;\n  padding-left: 30px !important;\n  padding-right: 20px;\n  height: 61px;\n}\n\n.ratingLabel {\n  margin-bottom: 0px !important;\n  color: white !important;\n  font-size: 17px !important;\n}\n\n.ratingIcon {\n  color: white !important;\n  margin-right: 9px !important;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
